module.exports = __webpack_public_path__ + "static/media/bence-correct.e1ab7e1a.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/bence-correct.mov
// module id = 223
// module chunks = 0